import React from "react";

const BillingInformationCustomMessage = (props: { customMessage: string }) => {
    const customMessages = props.customMessage.split("<br>");

    return (
        <React.Fragment>
            <div style={{ marginBottom: "10px" }} className={`inline row`}>
                {customMessages.map((message: string, index: number) => {
                    return (
                        <div className="form-row" key={index}>
                            <div className="col-xs-12 col-no-gutter">
                                <span className="required">{message}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </React.Fragment>
    );
};

export default BillingInformationCustomMessage;
